import { Liquid } from "liquidjs"

const engine = new Liquid()

export default engine
